if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.cartUpdateUnsubscriber = undefined;
    }

    connectedCallback() {
      console.log('Product recommendations: Component connected');
      console.log('Product recommendations: data-url:', this.dataset.url);
      console.log('Product recommendations: data-recommendation-area:', this.dataset.recommendationArea);
      
      // Show the component immediately without waiting for fetch
      this.style.display = 'block';
      this.classList.remove('hidden');
      
      // Update cart drawer items layout
      var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
      if(cartDrawerItemsFull) {
        cartDrawerItemsFull.classList.remove('cart-drawer-items__full');
      }
      
      // Listen for cart update events to refresh recommendations
      // Set this up BEFORE fetching so we can catch immediate updates
      if (!this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          (eventData) => {
            console.log('Product recommendations: Received cart update event:', eventData);
            
            // Extract the latest product ID from cart data
            if (eventData && eventData.cartData) {
              const cartData = eventData.cartData;
              let latestProductId = null;
              
              // Try to get product ID from items array
              if (cartData.items && cartData.items.length > 0) {
                latestProductId = cartData.items[0].product_id;
              }
              
              // If we have a product ID, update the URL and refresh
              if (latestProductId) {
                console.log('Product recommendations: Updating with product ID from cart update:', latestProductId);
                this.updateProductIdAndRefresh(latestProductId);
              } else {
                // Fallback: try to get product ID from DOM
                const cartItems = document.querySelectorAll('.cart-item');
                if (cartItems.length > 0) {
                  const firstCartItem = cartItems[0];
                  const productIdAttr = firstCartItem.dataset.productId || firstCartItem.getAttribute('data-product-id');
                  if (productIdAttr) {
                    this.updateProductIdAndRefresh(productIdAttr);
                  } else {
                    // Last resort: just refresh with current URL
                    this.performRecommendations();
                  }
                } else {
                  this.performRecommendations();
                }
              }
            } else {
              // No cart data, just refresh
              this.performRecommendations();
            }
          }
        );
      }
      
      // Check if recommendations container is empty
      const recommendations = this.querySelector('[data-recommendations]');
      const hasRecommendations = recommendations && recommendations.children.length > 0;
      
      console.log('Product recommendations: Has existing recommendations:', hasRecommendations);
      
      // Always fetch if URL exists, even if there are existing recommendations
      // This ensures we get the latest recommendations for the current product
      if (this.dataset.url) {
        console.log('Product recommendations: URL exists, fetching immediately');
        // Use requestAnimationFrame to ensure DOM is fully ready
        requestAnimationFrame(() => {
          this.performRecommendations();
        });
      } else {
        console.log('Product recommendations: No URL set, will construct one');
        // Try to construct URL and fetch
        requestAnimationFrame(() => {
          if (!this.dataset.url) {
            this.constructRecommendationsUrl();
          }
          if (this.dataset.url) {
            this.performRecommendations();
          }
        });
      }
    }

    // Public method to force refresh recommendations
    refreshRecommendations() {
      console.log('Product recommendations: Force refreshing recommendations');
      
      // Check if recommendations are already visible but hidden
      const recommendations = this.querySelector('[data-recommendations]');
      if (recommendations && recommendations.children.length > 0) {
        console.log('Product recommendations: Recommendations already exist, just showing component');
        this.classList.remove('hidden');
        // Force show with inline style to override !important CSS
        this.style.display = 'block';
        
        // Update cart drawer items layout
        var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
        if(cartDrawerItemsFull) {
          cartDrawerItemsFull.classList.remove('cart-drawer-items__full');
        }
        
        this.initSlider();
        return;
      }
      
      this.performRecommendations();
    }

    // Method to update the product ID in the URL and refresh
    updateProductIdAndRefresh(newProductId) {
      if (newProductId) {
        console.log('Product recommendations: Updating product ID to', newProductId);
        
        // Get section ID from current URL or try to find it from the cart drawer
        let sectionId = 'cart-drawer';
        if (this.dataset.url) {
          try {
            const url = new URL(this.dataset.url, window.location.origin);
            const existingSectionId = url.searchParams.get('section_id');
            if (existingSectionId) {
              sectionId = existingSectionId;
            }
          } catch (e) {
            console.log('Product recommendations: Could not parse URL, trying to find section ID from DOM');
          }
        }
        
        // Try to get section ID from cart drawer element
        if (sectionId === 'cart-drawer') {
          const cartDrawerElement = document.querySelector('cart-drawer');
          if (cartDrawerElement) {
            const drawerId = cartDrawerElement.querySelector('.cart-drawer')?.id;
            if (drawerId) {
              // Extract section ID from element ID (format: shopify-section-{id})
              const match = drawerId.match(/shopify-section-(.+)/);
              if (match) {
                sectionId = match[1];
              } else {
                sectionId = drawerId;
              }
            }
          }
        }
        
        // Construct new URL with updated product ID
        const recommendationsUrl = `${window.routes.product_recommendations_url}?section_id=${sectionId}&product_id=${newProductId}&limit=8&intent=complementary`;
        this.dataset.url = recommendationsUrl;
        console.log('Product recommendations: Updated URL:', recommendationsUrl);
        
        // Show the component immediately
        this.style.display = 'block';
        this.classList.remove('hidden');
        
        // Update cart drawer layout
        const cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
        if (cartDrawerItemsFull) {
          cartDrawerItemsFull.classList.remove('cart-drawer-items__full');
        }
        
        // Fetch recommendations immediately
        this.performRecommendations();
      } else {
        this.performRecommendations();
      }
    }

    // Force show recommendations immediately (for cart drawer)
    forceShowRecommendations() {
      console.log('Product recommendations: Force showing recommendations');
      
      // First, try to show existing recommendations
      const recommendations = this.querySelector('[data-recommendations]');
      if (recommendations && recommendations.children.length > 0) {
        console.log('Product recommendations: Showing existing recommendations');
        this.classList.remove('hidden');
        this.style.display = 'block';
        
        // Update cart drawer items layout
        var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
        if(cartDrawerItemsFull) {
          cartDrawerItemsFull.classList.remove('cart-drawer-items__full');
        }
        
        this.initSlider();
        return;
      }
      
      // If no existing recommendations, fetch new ones
      console.log('Product recommendations: No existing recommendations, fetching new ones');
      this.performRecommendations();
    }

    // Construct recommendations URL if not set
    constructRecommendationsUrl() {
      console.log('Product recommendations: Constructing URL');
      
      // Try multiple methods to get product ID
      let productId = null;
      
      // Method 1: Try to get from cart item data attributes
      const cartItems = document.querySelectorAll('.cart-item');
      if (cartItems.length > 0) {
        const firstCartItem = cartItems[0];
        // Try data-product-id attribute
        productId = firstCartItem.dataset.productId || firstCartItem.getAttribute('data-product-id');
        
        // Method 2: Try to extract from product link
        if (!productId) {
          const productLink = firstCartItem.querySelector('a[href*="/products/"]');
          if (productLink) {
            // Extract product handle from URL (Shopify can use handle as product_id in some cases)
            const productHandle = productLink.href.split('/products/')[1].split('?')[0].split('#')[0];
            productId = productHandle;
            console.log('Product recommendations: Found product handle:', productHandle);
          }
        }
      }
      
      if (productId) {
        const sectionId = this.dataset.recommendationArea === 'cart-drawer' ? 'cart-drawer' : 'product-recommendations';
        const recommendationsUrl = `${window.routes.product_recommendations_url}?section_id=${sectionId}&product_id=${productId}&limit=8&intent=complementary`;
        this.dataset.url = recommendationsUrl;
        console.log('Product recommendations: Constructed URL:', recommendationsUrl);
        return true;
      }
      
      console.log('Product recommendations: Could not construct URL - no cart items found');
      return false;
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }

    performRecommendations() {
      const recommendations = this.querySelector(
        '[data-recommendations]'
      );
      if (!recommendations) {
        console.log('Product recommendations: No recommendations container found');
        return;
      }
      
      // If no URL is set, try to construct one
      if (!this.dataset.url) {
        console.log('Product recommendations: No URL set, attempting to construct one');
        const constructed = this.constructRecommendationsUrl();
        if (!constructed) {
          console.log('Product recommendations: Could not construct URL, will retry');
          // Retry after a short delay to allow DOM to update
          setTimeout(() => {
            if (!this.dataset.url) {
              this.constructRecommendationsUrl();
            }
            if (this.dataset.url) {
              this.performRecommendations();
            }
          }, 100);
          return;
        }
      }
      
      if (!this.dataset.url) {
        console.log('Product recommendations: Still no URL available, cannot fetch recommendations');
        return;
      }
      
      console.log('Product recommendations: Fetching from URL:', this.dataset.url);
      
      // Show loading state
      this.style.display = 'block';
      this.classList.remove('hidden');
      
      fetch(this.dataset.url)
        .then(response => {
          console.log('Product recommendations: Fetch response status:', response.status);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text();
        })
        .then(text => {
          console.log('Product recommendations: Received response text length:', text.length);
          
          // Parse the response HTML
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          
          // Try multiple methods to find the recommendations content
          let recommendationsHTML = null;
          
          // Method 1: Look for [data-recommendations] directly
          const dataRecommendations = doc.querySelector('[data-recommendations]');
          if (dataRecommendations) {
            recommendationsHTML = dataRecommendations.innerHTML;
            console.log('Product recommendations: Found [data-recommendations] in response');
          }
          
          // Method 2: Look for product-recommendations element, then [data-recommendations]
          if (!recommendationsHTML) {
            const productRecommendationsElement = doc.querySelector('product-recommendations [data-recommendations]');
            if (productRecommendationsElement) {
              recommendationsHTML = productRecommendationsElement.innerHTML;
              console.log('Product recommendations: Found product-recommendations [data-recommendations] in response');
            }
          }
          
          // Method 3: Look for the entire product-recommendations element content
          if (!recommendationsHTML) {
            const productRecommendations = doc.querySelector('product-recommendations');
            if (productRecommendations) {
              const innerDataRecommendations = productRecommendations.querySelector('[data-recommendations]');
              if (innerDataRecommendations) {
                recommendationsHTML = innerDataRecommendations.innerHTML;
                console.log('Product recommendations: Found nested [data-recommendations] in response');
              }
            }
          }
          
          // Method 4: Look for .product-recommendations__items
          if (!recommendationsHTML) {
            const itemsContainer = doc.querySelector('.product-recommendations__items');
            if (itemsContainer) {
              recommendationsHTML = itemsContainer.innerHTML;
              console.log('Product recommendations: Found .product-recommendations__items in response');
            }
          }
          
          if (!recommendationsHTML || recommendationsHTML.trim() === '') {
            console.log('Product recommendations: No recommendations HTML found in response');
            console.log('Product recommendations: Response HTML:', text.substring(0, 500));
            // Keep the component visible even if no recommendations
            this.style.display = 'block';
            
            // Add a placeholder message
            const recommendations = this.querySelector('[data-recommendations]');
            if (recommendations) {
              recommendations.innerHTML = '<p style="text-align: center; padding: 2rem; color: #666;">No recommendations available</p>';
            }
            return;
          }
          
          console.log('Product recommendations: Found recommendations HTML, length:', recommendationsHTML.length);
          this.classList.remove('hidden');
          // Force show with inline style to override !important CSS
          this.style.display = 'block';
          
          // Update cart drawer items layout when recommendations are loaded
          var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if(cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('cart-drawer-items__full');
          }
          
          // Update the recommendations container
          const recommendations = this.querySelector('[data-recommendations]');
          if (recommendations) {
            recommendations.innerHTML = recommendationsHTML;
            this.initSlider();
          } else {
            console.error('Product recommendations: Could not find [data-recommendations] container to update');
          }

          // initiate quick cart after fetch
          // to activate trigger button events
          setTimeout(() => {
            if (document.querySelector("quick-cart-drawer")) {
              document.querySelector("quick-cart-drawer").init();
            } else {
              // if quick-cart-drawer does not exists, remove trigger buttons
              this.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
                el?.remove();
              })
            }
          }, 500);

        })
        .catch(error => {
          console.error('Error loading product recommendations:', error);
          // Keep component visible even on error
          this.style.display = 'block';
        });
    }

    initSlider() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
      });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}

// Global observer to watch for product recommendations components being added to the DOM
// This ensures they get initialized even when added dynamically (like after cart updates)
(function() {
  const initializeProductRecommendations = (element) => {
    if (!element || element.tagName !== 'PRODUCT-RECOMMENDATIONS') return;
    
    console.log('Product recommendations: MutationObserver detected new element, initializing...');
    
    // Ensure component is visible immediately
    element.style.display = 'block';
    element.classList.remove('hidden');
    
    // Update cart drawer layout
    const cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
    if (cartDrawerItemsFull) {
      cartDrawerItemsFull.classList.remove('cart-drawer-items__full');
    }
    
    // Force initialization if methods exist
    if (typeof element.performRecommendations === 'function') {
      // Small delay to ensure DOM is ready
      requestAnimationFrame(() => {
        element.performRecommendations();
      });
    } else if (typeof element.refreshRecommendations === 'function') {
      requestAnimationFrame(() => {
        element.refreshRecommendations();
      });
    }
  };
  
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          // Check if the added node is a product-recommendations element
          if (node.tagName === 'PRODUCT-RECOMMENDATIONS') {
            initializeProductRecommendations(node);
          }
          
          // Check if any child elements are product-recommendations
          const productRecommendations = node.querySelectorAll && node.querySelectorAll('product-recommendations');
          if (productRecommendations && productRecommendations.length > 0) {
            productRecommendations.forEach(component => {
              initializeProductRecommendations(component);
            });
          }
        }
      });
    });
  });

  // Start observing immediately (don't wait for DOMContentLoaded)
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  } else {
    // If body doesn't exist yet, wait for it
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }
  
  // Also check for existing elements on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      const existingElements = document.querySelectorAll('product-recommendations');
      existingElements.forEach(element => {
        if (element.isConnected) {
          initializeProductRecommendations(element);
        }
      });
    });
  } else {
    // DOM already loaded
    const existingElements = document.querySelectorAll('product-recommendations');
    existingElements.forEach(element => {
      if (element.isConnected) {
        initializeProductRecommendations(element);
      }
    });
  }
})();

// Global function to force show product recommendations
window.forceShowProductRecommendations = function() {
  console.log('Global function: Force showing product recommendations');
  let productRecommendations = document.querySelector('product-recommendations');
  
  // If no product recommendations exist, try to create one
  if (!productRecommendations) {
    console.log('Global function: No product recommendations found, creating one');
    productRecommendations = document.createElement('product-recommendations');
    productRecommendations.className = 'product-recommendations cart-drawer__recommendations';
    productRecommendations.setAttribute('data-recommendation-area', 'cart-drawer');
    
    // Create the basic structure
    productRecommendations.innerHTML = `
      <div class="swiper product-recommendations__body">
        <div class="product-recommendations__items swiper-wrapper" data-recommendations>
          <!-- Recommendations will be loaded here -->
        </div>
      </div>
    `;
    
    // Find where to insert the recommendations
    const cartDrawerItems = document.querySelector('.cart-drawer-items');
    if (cartDrawerItems && cartDrawerItems.parentNode) {
      cartDrawerItems.parentNode.insertBefore(productRecommendations, cartDrawerItems.nextSibling);
      console.log('Global function: Product recommendations element created and inserted');
    } else {
      console.log('Global function: Could not find insertion point for product recommendations');
      return;
    }
  }
  
  if (productRecommendations && typeof productRecommendations.forceShowRecommendations === 'function') {
    productRecommendations.forceShowRecommendations();
  } else if (productRecommendations && typeof productRecommendations.refreshRecommendations === 'function') {
    productRecommendations.refreshRecommendations();
  } else {
    console.log('No product recommendations component found or methods not available');
  }
};
